import { StyleSheet, Text, View } from "@react-pdf/renderer";
import React, { useEffect, useState } from "react";

const RaiseInvoicePdfMainContentView = ({ receiptPdfData }) => {
  const styles = StyleSheet.create({
    receiptMainContentContainer: {
      marginTop: "22px",
    },
    receiptTitle: {
      color: "#171717",
      fontFamily: "notosans",
      fontSize: "12px",
      marginBottom: "22px",
      textAlign: "center",
    },
    userDetailsLabelValueContainer: {
      color: "#171717",
      fontFamily: "notosans",
      fontSize: "8px",
      display: "flex",
      flexDirection: "row",
      marginBottom: "5px",
    },
    userDetailsHeaderLabel: {
      width: "100px",
    },
    userDetailsWrapper: {
      display: "flex",
      flexDirection: "row",
      padding: "0px 22px",
    },
    userDetailsLeftContent: {
      width: "50%",
    },
    userDetailsRightContent: {
      width: "50%",
    },
    seperator: {
      marginRight: "4px",
    },
    userDetailsHeaderValue: {
      width: "50%",
    },
    receiptTableContainer: {
      marginTop: "22px",
    },
    receiptTableHeaderContainer: {
      display: "flex",
      flexDirection: "row",
      color: "#171717",
      fontFamily: "notosans",
      fontSize: "7px",
      fontWeight: "500",
      backgroundColor: "#F8F8F8",
    },
    receiptTableContentContainer: {
      display: "flex",
      flexDirection: "row",
      color: "#171717",
      fontFamily: "notosans",
      fontSize: "7px",
    },
    receiptSlNo: {
      width: "7%",
      padding: "8px 3px",
      textAlign: "center",
      fontWeight: "500",
    },
    receiptService: {
      width: "18%",
      padding: "8px 3px",
    },
    receiptHsn: {
      maxWidth: "8%",
      minWidth: "6%",
      padding: "8px 4px 8px 0px ",
      flexWrap: "wrap",
    },
    receiptHsnValue: {
      width: "100%",
      textAlign: "left",
      wordBreak: "break-all",
      paddingRight: "4px",
    },
    receiptFee: {
      width: "10%",
      padding: "8px 3px",
    },
    receiptIgst: {
      width: "5%",
      padding: "8px 3px",
    },
    receiptCgst: {
      width: "7%",
      padding: "8px 3px",
    },
    receiptSgst: {
      width: "7%",
      padding: "8px 3px",
    },
    receiptDiscount: {
      width: "10%",
      padding: "8px 3px",
    },
    receiptRefund: {
      width: "10%",
      padding: "8px 3px",
    },
    receiptPartialAmt: {
      width: "10%",
      padding: "8px 3px",
    },
    receiptAmt: {
      width: "10%",
      padding: "8px 3px",
    },
    paymentMethodsContainer: {
      display: "flex",
      flexDirection: "row",
      padding: "0px 22px",
      fontSize: "7px",
      fontFamily: "notosans",
      marginTop: "10px",
    },
    paymentContainer: {
      display: "flex",
      flexDirection: "row",
      fontSize: "8px",
    },
    paymentDate: {
      width: "22%",
      padding: "8px 5px",
    },
    paymentType: {
      width: "22%",
      padding: "8px 5px",
    },
    paymentMethod: {
      width: "22%",
      padding: "8px 5px",
    },
    paymentAmount: {
      width: "22%",
      padding: "8px 5px",
    },
    totalAmtLabelValue: {
      display: "flex",
      flexDirection: "row",
    },
    totalAmtLabel: {
      width: "70%",
      padding: "8px 5px",
      textAlign: "right",
    },
    totalAmtValue: {
      width: "40%",
      padding: "8px 5px",
      textAlign: "right",
      fontSize: "8px",
    },
    totalLeftContent: {
      width: "70%",
      fontSize: "8px",
    },
    totalRightContent: {
      width: "30%",
      fontSize: "8px",
    },
    totalAndNetAmtContainer: {
      display: "flex",
      flexDirection: "row",
      borderTop: "1px solid #e1e1e1",
      fontSize: "8px",
      fontFamily: "notosans",
      padding: "10px",
    },
    totalAmountInWords: {
      display: "flex",
      flexDirection: "row",
      width: "70%",
    },
    netAmountContainer: {
      display: "flex",
      flexDirection: "row",
      width: "30%",
      textAlign: "right",
    },
    amtInWords: {
      fontWeight: "500",
      marginRight: "3px",
      width: "23%",
    },
    netAmount: {
      fontWeight: "500",
      marginLeft: "3px",
      width: "30%",
      textAlign: "right",
      fontSize: "8px",
    },
    totalAmountInWordsValue: {
      width: "75%",
      paddingRight: "10px",
    },
    netAmountLabel: {
      width: "60%",
    },

    remarkContainer: {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      borderTop: "1px solid #e1e1e1",
      fontSize: "8px",
      fontFamily: "notosans",
      padding: "10px",
      alignItems: "center",
    },

    remarkTitle: {
      fontWeight: "500",
      marginRight: "3px",
    },
    remarkValue: {
      fontWeight: "400",
      marginLeft: "3px",
      textAlign: "right",
      fontSize: "8px",
    },
  });

  const [receiptMainContent, setReceiptMainContent] = useState({});

  useEffect(() => {
    if (receiptPdfData) {
      setReceiptMainContent({ ...receiptPdfData?.payload_reciept });
    }
  }, [receiptPdfData]);

  const getPatientAge = (receiptMainContent) => {
    let value = receiptMainContent?.PATIENT_AGE,
      display_age = "-";
    if (value) {
      let year = value?.split("years");
      let month = year[1]?.split("months");
      let day = month[1]?.split("days");
      let yy = year && Number(year[0]?.trim());
      let mm = month && Number(month[0]?.trim());
      let dd = day && Number(day[0]?.trim());
      if (yy == 0 && mm == 0 && dd == 0) {
        display_age = "1 D";
      } else {
        display_age = `${yy > 0 ? yy + "Y" : ""}${
          mm > 0 ? " " + mm + "M" : ""
        }${dd > 0 ? " " + dd + "D" : ""}`;
      }
      return display_age;
    }
    return "-";
  };

  const getDoctorName = (receiptMainContent) => {
    return receiptMainContent?.is_doctor_name_enabled
      ? receiptMainContent?.DOCTOR_FULL_NAME
      : "-";
  };

  const getDoctorDegreeDetails = () => {
    return `${
      (receiptMainContent?.is_doctor_degree_enabled &&
      receiptMainContent?.DOCTOR_DEGREE
        ? receiptMainContent?.DOCTOR_DEGREE
        : "-") +
      (receiptMainContent?.is_doctor_registration_number_enabled &&
      receiptMainContent?.DOCTOR_MEDICAL_REG_NO
        ? "/" + receiptMainContent?.DOCTOR_MEDICAL_REG_NO
        : "-")
    }`;
  };

  const getDoctorContactAndEmail = (receiptMainContent) => {
    let contactAndEmail = `${
      (receiptMainContent?.is_doctor_registered_mob_no_enabled &&
      receiptMainContent?.DOCTOR_PHONE
        ? receiptMainContent?.DOCTOR_PHONE
        : "") +
      (receiptMainContent?.is_doctor_alternate_no_enabled &&
      receiptMainContent?.DOCTOR_ALTERNATE_NUMBER
        ? "," + receiptMainContent?.DOCTOR_ALTERNATE_NUMBER
        : "") +
      (receiptMainContent?.is_doctor_registered_email_enabled &&
      receiptMainContent?.DOCTOR_EMAIL
        ? "/" + receiptMainContent?.DOCTOR_EMAIL
        : "")
    }`;
    return contactAndEmail ? contactAndEmail : "-";
  };

  const getPatientContactAndEmail = (receiptMainContent) => {
    let contactAndEmail = `${
      (receiptMainContent?.PATIENT_PHONE
        ? receiptMainContent?.PATIENT_PHONE
        : "") +
      (receiptMainContent?.PATIENT_EMAIL
        ? "/" + receiptMainContent?.PATIENT_EMAIL
        : "")
    }`;
    return contactAndEmail ? contactAndEmail : "-";
  };

  const displayUserDetailItem = (label, value, valueStyle) => {
    return (
      <View style={styles.userDetailsLabelValueContainer}>
        <Text style={styles.userDetailsHeaderLabel}>{label}</Text>
        <Text style={styles.seperator}>:</Text>
        <Text
          style={[
            styles.userDetailsHeaderValue,
            {
              ...valueStyle,
            },
          ]}
        >
          {value && value !== "" ? value : "-"}
        </Text>
      </View>
    );
  };

  const displayPatientDetails = () => {
    return (
      <View style={styles.userDetailsLeftContent}>
        {(receiptMainContent?.HEADER_HOSPITAL_DATA &&
          receiptMainContent?.custom_margins_enabled) ||
        !receiptMainContent?.HEADER_HOSPITAL_DATA
          ? displayUserDetailItem(
              "Receipt Date",
              receiptMainContent?.INVOICE_DATE
                ? receiptMainContent?.INVOICE_DATE
                : "-"
            )
          : null}
        {displayUserDetailItem(
          "Patient Name",
          receiptMainContent?.PATIENT_NAME
            ? receiptMainContent?.PATIENT_NAME
            : "-",
          { fontWeight: "500" }
        )}
        {displayUserDetailItem("Age", getPatientAge(receiptMainContent))}
        {displayUserDetailItem(
          "State Code",
          receiptMainContent?.PATIENT_STATE_CODE
            ? receiptMainContent?.PATIENT_STATE_CODE
            : "-"
        )}
        {displayUserDetailItem(
          "Place of Supply",
          receiptMainContent?.PATIENT_STATE
            ? receiptMainContent?.PATIENT_STATE
            : "-"
        )}
        {displayUserDetailItem(
          "Address",
          receiptMainContent?.PATIENT_ADDRESS
            ? receiptMainContent?.PATIENT_ADDRESS
            : "-"
        )}
        {displayUserDetailItem(
          "Contact/Email",
          getPatientContactAndEmail(receiptMainContent)
        )}
        {!receiptMainContent?.displayMultiplePaymentMethods &&
        !receiptMainContent.displayPartialAmountDetails
          ? displayUserDetailItem(
              "Mode of Payment",
              receiptMainContent?.PAYMENT_MODE
                ? receiptMainContent?.PAYMENT_MODE
                : "-"
            )
          : null}
        {(receiptMainContent?.HEADER_HOSPITAL_DATA &&
          receiptMainContent?.custom_margins_enabled) ||
        !receiptMainContent?.HEADER_HOSPITAL_DATA
          ? receiptMainContent?.formatted_uhid
            ? displayUserDetailItem("UHID", receiptMainContent?.formatted_uhid)
            : null
          : null}
      </View>
    );
  };

  const displayDoctorDetails = () => {
    return (
      <View style={styles.userDetailsRightContent}>
        {(receiptMainContent?.HEADER_HOSPITAL_DATA &&
          receiptMainContent?.custom_margins_enabled) ||
        !receiptMainContent?.HEADER_HOSPITAL_DATA
          ? displayUserDetailItem(
              "Receipt No",
              receiptMainContent?.RECIEPT_NO
                ? receiptMainContent?.RECIEPT_NO
                : "-"
            )
          : null}
        {!receiptMainContent?.is_resource
          ? displayUserDetailItem(
              "Doctor Name",
              getDoctorName(receiptMainContent),
              { fontWeight: "500" }
            )
          : null}
        {!receiptMainContent?.is_resource
          ? displayUserDetailItem("Degree/Regd No", getDoctorDegreeDetails())
          : null}
        {displayUserDetailItem(
          "GSTIN (HCP if any)",
          receiptMainContent?.DOCTOR_GST_NUMBER
            ? receiptMainContent?.DOCTOR_GST_NUMBER
            : "-"
        )}
        {displayUserDetailItem(
          "State Code",
          receiptMainContent?.DOCTOR_STATE_CODE
            ? receiptMainContent?.DOCTOR_STATE_CODE
            : "-"
        )}
        {displayUserDetailItem(
          "Contact/Email",
          getDoctorContactAndEmail(receiptMainContent)
        )}
        {receiptMainContent?.referred_by !== ""
          ? displayUserDetailItem(
              "Referred By",
              receiptMainContent?.referred_by
                ? receiptMainContent?.referred_by
                : "-"
            )
          : null}
      </View>
    );
  };

  const displayReceiptMainContent = () => {
    return (
      <View>
        <Text style={styles.receiptTitle}>Receipt</Text>
        <View style={styles.userDetailsWrapper}>
          {displayPatientDetails()}
          {displayDoctorDetails()}
        </View>
        <View style={styles.receiptTableContainer}>
          {displayReceiptTable()}
        </View>
        {displayPaymentMethodsAndTotalAmount()}
        {displayTotalAmountInWords()}
        {receiptMainContent?.is_remark &&
          receiptMainContent?.remark_note?.trim() !== "" &&
          displayRemarkUi()}
      </View>
    );
  };

  const displayReceiptTableHeader = () => {
    return (
      <View style={styles.receiptTableHeaderContainer}>
        <View style={styles.receiptSlNo}>
          <Text>Sr No.</Text>
        </View>
        <View style={styles.receiptService}>
          <Text>Description of Service</Text>
        </View>
        <View style={styles.receiptHsn}>
          <Text>HSN</Text>
        </View>
        <View
          style={[
            styles.receiptFee,
            {
              width: receiptMainContent?.displayPartialAmountDetails
                ? "10%"
                : "12%",
            },
          ]}
        >
          <Text>Fee</Text>
        </View>
        <View style={styles.receiptIgst}>
          <Text>IGST</Text>
        </View>
        <View style={styles.receiptCgst}>
          <Text>CGST</Text>
        </View>
        <View style={styles.receiptSgst}>
          <Text>SGST</Text>
        </View>
        <View
          style={[
            styles.receiptDiscount,
            {
              width: receiptMainContent?.displayPartialAmountDetails
                ? "10%"
                : "12%",
            },
          ]}
        >
          <Text>Discount</Text>
        </View>
        <View
          style={[
            styles.receiptRefund,
            {
              width: receiptMainContent?.displayPartialAmountDetails
                ? "10%"
                : "12%",
            },
          ]}
        >
          <Text>Refund</Text>
        </View>
        {receiptMainContent?.displayPartialAmountDetails ? (
          <View
            style={[
              styles.receiptPartialAmt,
              {
                width: receiptMainContent?.displayPartialAmountDetails
                  ? "10%"
                  : "12%",
              },
            ]}
          >
            <Text>Partial Amount</Text>
          </View>
        ) : null}
        <View
          style={[
            styles.receiptAmt,
            {
              width: receiptMainContent?.displayPartialAmountDetails
                ? "10%"
                : "12%",
            },
          ]}
        >
          <Text>Amount</Text>
        </View>
      </View>
    );
  };

  const formatText = (text, maxLength = 10) => {
    if (text.length > maxLength) {
      return (
        text.substring(0, maxLength) + "\u200B" + text.substring(maxLength)
      );
    }
    return text;
  };

  const displayReceiptTableContent = () => {
    return (
      <View>
        {receiptMainContent?.CONSULTATION_FEE_DETAILS_LIST?.map(
          (data, index) => (
            <View style={styles.receiptTableContentContainer} key={index}>
              <View style={styles.receiptSlNo}>
                <Text>{index + 1}</Text>
              </View>
              <View style={styles.receiptService}>
                <Text>{data?.procedure_name ? data?.procedure_name : "-"}</Text>
              </View>
              <View style={styles.receiptHsn}>
                <Text style={styles.receiptHsnValue}>
                  {formatText(data?.hsn ? data?.hsn.split("") : "-")}
                </Text>
              </View>
              <View
                style={[
                  styles.receiptFee,
                  {
                    width: receiptMainContent?.displayPartialAmountDetails
                      ? "10%"
                      : "12%",
                  },
                ]}
              >
                <Text>₹{data?.fee}</Text>
              </View>
              <View style={styles.receiptIgst}>
                <Text>₹{data?.igst_percent}</Text>
              </View>
              <View style={styles.receiptCgst}>
                <Text>₹{data?.cgst_percent}</Text>
              </View>
              <View style={styles.receiptSgst}>
                <Text>₹{data?.sgst_percent}</Text>
              </View>
              <View
                style={[
                  styles.receiptDiscount,
                  {
                    width: receiptMainContent?.displayPartialAmountDetails
                      ? "10%"
                      : "12%",
                  },
                ]}
              >
                <Text>
                  {data?.discount != "0" ? "-" : ""}₹{data?.discount}
                </Text>
              </View>
              <View
                style={[
                  styles.receiptRefund,
                  {
                    width: receiptMainContent?.displayPartialAmountDetails
                      ? "10%"
                      : "12%",
                  },
                ]}
              >
                <Text>₹{data?.refund}</Text>
              </View>
              {data?.showPartialAmount ? (
                <View
                  style={[
                    styles.receiptPartialAmt,
                    {
                      width: receiptMainContent?.displayPartialAmountDetails
                        ? "10%"
                        : "12%",
                    },
                  ]}
                >
                  <Text>₹{data?.partial_amount}</Text>
                </View>
              ) : null}
              <View
                style={[
                  styles.receiptAmt,
                  {
                    width: receiptMainContent?.displayPartialAmountDetails
                      ? "10%"
                      : "12%",
                  },
                ]}
              >
                <Text>₹{data?.final_amount}</Text>
              </View>
            </View>
          )
        )}
        <View style={styles.receiptTableHeaderContainer}>
          <View style={styles.receiptSlNo}></View>
          <View style={styles.receiptService}>
            <Text>Total</Text>
          </View>
          <View style={styles.receiptHsn}></View>
          <View
            style={[
              styles.receiptFee,
              {
                width: receiptMainContent?.displayPartialAmountDetails
                  ? "10%"
                  : "12%",
              },
            ]}
          ></View>
          <View style={styles.receiptIgst}>
            <Text>₹{receiptMainContent?.TOTAL_IGST_PERCENT}</Text>
          </View>
          <View style={styles.receiptCgst}>
            <Text>₹{receiptMainContent?.TOTAL_CGST_PERCENT}</Text>
          </View>
          <View style={styles.receiptSgst}>
            <Text>₹{receiptMainContent?.TOTAL_SGST_PERCENT}</Text>
          </View>
          <View
            style={[
              styles.receiptDiscount,
              {
                width: receiptMainContent?.displayPartialAmountDetails
                  ? "10%"
                  : "12%",
              },
            ]}
          >
            <Text>
              {receiptMainContent?.TOTAL_DISCOUNT != "0" ? "-" : ""}₹
              {receiptMainContent?.TOTAL_DISCOUNT}
            </Text>
          </View>
          <View
            style={[
              styles.receiptRefund,
              {
                width: receiptMainContent?.displayPartialAmountDetails
                  ? "10%"
                  : "12%",
              },
            ]}
          >
            {receiptMainContent?.TOTAL_REFUND !== "" ? (
              <Text>₹{receiptMainContent?.TOTAL_REFUND}</Text>
            ) : null}
          </View>
          {receiptMainContent?.displayPartialAmountDetails ? (
            <View
              style={[
                styles.receiptPartialAmt,
                {
                  width: receiptMainContent?.displayPartialAmountDetails
                    ? "10%"
                    : "12%",
                },
              ]}
            >
              {receiptMainContent?.total_partial_amount !== "" ? (
                <Text>₹{receiptMainContent?.total_partial_amount}</Text>
              ) : null}
            </View>
          ) : null}
          <View
            style={[
              styles.receiptAmt,
              {
                width: receiptMainContent?.displayPartialAmountDetails
                  ? "10%"
                  : "12%",
              },
            ]}
          >
            {receiptMainContent?.TOTAL_FINAL_AMOUNT !== "" ? (
              <Text>₹{receiptMainContent?.TOTAL_FINAL_AMOUNT}</Text>
            ) : null}
          </View>
        </View>
      </View>
    );
  };

  const displayPaymentMethods = () => {
    return (
      <View style={styles.totalLeftContent}>
        {receiptMainContent?.displayPartialAmountDetails && (
          <View style={styles.paymentContainer}>
            <View style={styles.paymentDate}>
              <Text>{receiptMainContent?.PARTIAL_AMOUNT_DETAILS?.date}</Text>
            </View>
            <View style={styles.paymentType}>
              <Text>{receiptMainContent?.PARTIAL_AMOUNT_DETAILS?.name}</Text>
            </View>
            <View style={styles.paymentMethod}>
              <Text>{receiptMainContent?.PARTIAL_AMOUNT_DETAILS?.type}</Text>
            </View>
            <View style={styles.paymentAmount}>
              <Text>₹{receiptMainContent?.PARTIAL_AMOUNT_DETAILS?.amount}</Text>
            </View>
          </View>
        )}
        {receiptMainContent?.displayMultiplePaymentMethods &&
          receiptMainContent?.multiple_payment_methods_details?.map(
            (data, index) => (
              <View style={styles.paymentContainer} key={index}>
                <View style={styles.paymentDate}>
                  <Text> {data?.date}</Text>
                </View>
                <View style={styles.paymentType}>
                  <Text>{data?.type}</Text>
                </View>
                <View
                  style={[
                    styles.paymentMethod,
                    { color: data?.payment_method === "Refund" ? "red" : "" },
                  ]}
                >
                  <Text>{data?.payment_method}</Text>
                </View>
                <View style={styles.paymentAmount}>
                  <Text>
                    {data?.payment_method === "Refund" ? "-" : ""}₹
                    {data?.amount}
                  </Text>
                </View>
              </View>
            )
          )}
      </View>
    );
  };

  const displayTotalAmount = () => {
    return (
      <View style={styles.totalRightContent}>
        <View style={styles.totalAmtLabelValue}>
          <View style={styles.totalAmtLabel}>
            <Text>Total Amount</Text>
          </View>
          <View style={styles.totalAmtValue}>
            <Text>₹{receiptMainContent?.TOTAL_FINAL_AMOUNT}</Text>
          </View>
        </View>
        {receiptMainContent?.total_partial_amount !== "" &&
          receiptMainContent?.total_partial_amount != 0 && (
            <View style={styles.totalAmtLabelValue}>
              <View style={styles.totalAmtLabel}>
                <Text>Partial Amount Paid</Text>
              </View>
              <View style={styles.totalAmtValue}>
                <Text>₹{receiptMainContent?.total_partial_amount}</Text>
              </View>
            </View>
          )}
        {receiptMainContent?.pending_amount !== "" &&
          receiptMainContent?.pending_amount != 0 && (
            <View style={styles.totalAmtLabelValue}>
              <View style={styles.totalAmtLabel}>
                <Text>Pending Amount</Text>
              </View>
              <View style={styles.totalAmtValue}>
                <Text>₹{receiptMainContent?.pending_amount}</Text>
              </View>
            </View>
          )}
      </View>
    );
  };

  const displayRemarkUi = () => {
    return (
      <View style={styles.remarkContainer}>
        <View style={styles.remarkTitle}>
          <Text>Remark:</Text>
        </View>
        <View style={styles.remarkValue}>
          <Text>{receiptMainContent?.remark_note}</Text>
        </View>
      </View>
    );
  };

  const displayTotalAmountInWords = () => {
    return (
      <View style={styles.totalAndNetAmtContainer}>
        <View style={styles.totalAmountInWords}>
          <View style={styles.amtInWords}>
            <Text>Amount in words:</Text>
          </View>
          <View style={styles.totalAmountInWordsValue}>
            <Text>{receiptMainContent?.amount_in_words}</Text>
          </View>
        </View>
        <View style={styles.netAmountContainer}>
          <View style={styles.netAmountLabel}>
            <Text>Net Amount Received</Text>
          </View>
          <View style={styles.netAmount}>
            <Text>₹{receiptMainContent?.total_payment_methods}</Text>
          </View>
        </View>
      </View>
    );
  };
  const displayPaymentMethodsAndTotalAmount = () => {
    return (
      <View style={styles.paymentMethodsContainer}>
        {displayPaymentMethods()}
        {displayTotalAmount()}
      </View>
    );
  };

  const displayReceiptTable = () => {
    return (
      <View>
        {displayReceiptTableHeader()}
        {displayReceiptTableContent()}
      </View>
    );
  };

  return (
    <View style={styles.receiptMainContentContainer}>
      {Object?.keys(receiptMainContent)?.length > 0 &&
        displayReceiptMainContent()}
    </View>
  );
};

export default RaiseInvoicePdfMainContentView;
